var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 28,
    viewBox: "0 0 86 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61364 4.94316V22.3977H1.9233V4.94316H5.61364ZM14.8374 22.3977H8.64986V4.94316H14.8885C16.6442 4.94316 18.1555 5.29259 19.4226 5.99146C20.6896 6.68464 21.6641 7.6818 22.3459 8.98293C23.0334 10.2841 23.3771 11.8409 23.3771 13.6534C23.3771 15.4716 23.0334 17.0341 22.3459 18.3409C21.6641 19.6477 20.6839 20.6505 19.4055 21.3494C18.1328 22.0483 16.6101 22.3977 14.8374 22.3977ZM12.3402 19.2358H14.6839C15.7749 19.2358 16.6925 19.0426 17.4368 18.6562C18.1868 18.2642 18.7493 17.6591 19.1243 16.8409C19.505 16.017 19.6953 14.9545 19.6953 13.6534C19.6953 12.3636 19.505 11.3096 19.1243 10.4915C18.7493 9.67327 18.1896 9.071 17.4453 8.68464C16.701 8.29827 15.7834 8.10509 14.6925 8.10509H12.3402V19.2358Z",
    fill: "url(#paint0_linear_1_15395)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9817 0.842168C75.6889 1.86511 75.4702 2.7399 75.188 3.59353C73.7912 7.78759 72.3802 11.9746 70.7506 16.8283C69.3255 12.9129 68.1368 9.64652 66.9057 6.27081C64.8528 6.27081 62.9304 6.27081 60.5353 6.27081C63.1349 12.285 65.6076 17.9994 68.1579 23.8972C69.6782 23.8972 71.195 23.8972 73.0116 23.8972C75.9605 16.6025 78.9588 9.19502 82.0029 1.6711C84.3874 2.9586 85.3716 4.87397 85.4245 7.14561C85.5303 11.7347 85.5056 16.3344 85.3927 20.9236C85.301 24.7508 82.5426 27.3787 78.6978 27.3857C64.9903 27.414 51.2794 27.421 37.572 27.3963C33.7024 27.3893 31.0287 24.7684 30.9511 20.8918C30.8594 16.2992 30.8382 11.7065 30.8805 7.11386C30.9123 3.88277 33.3003 0.930353 36.3974 0.898606C49.5263 0.764565 62.6552 0.842168 75.9817 0.842168ZM59.6605 9.17738C57.2724 6.01684 52.1154 4.87044 48.073 6.42602C44.0588 7.96749 41.7978 11.7171 42.1893 16.1898C42.5491 20.3274 45.6391 23.4915 50.3129 24.5074C53.6181 25.227 58.246 23.4633 59.6605 20.8107C58.6904 19.7278 57.6816 18.6026 56.7045 17.5126C53.1948 19.7454 50.8314 19.7913 49.0219 17.8018C47.6779 16.3239 47.6497 13.7101 48.9619 12.1369C50.5457 10.2356 53.1101 10.3344 56.7327 12.5072C57.2795 11.9252 57.8615 11.3291 58.4153 10.7083C58.8315 10.2356 59.209 9.73118 59.6605 9.17738ZM40.1364 21.8548C40.0799 19.9994 38.7184 18.6484 36.9159 18.6555C34.997 18.6625 33.6354 20.077 33.6707 22.0276C33.706 24.0418 35.057 25.3152 37.0464 25.2164C38.7783 25.1317 40.1893 23.5938 40.1364 21.8548Z",
    fill: "url(#paint1_linear_1_15395)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_15395",
    x1: 12.5,
    y1: 4.39771,
    x2: 12.5,
    y2: 23.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0594E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_15395",
    x1: 58.1758,
    y1: 0.819824,
    x2: 58.1758,
    y2: 27.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0594E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.5908,
    height: 27.7954,
    fill: "white",
    transform: "translate(85.9397 27.7954) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo-colored.ec4b33ac455ba0b783faeb55148391b1.svg";
export { ForwardRef as ReactComponent };